import {ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST, set_one} from '@/store/mutation-mixins'

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    SET_ONE: set_one({ to: 'entities' }),

}
